// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  name:'dev',
  config: {
    SERVER_URL:"https://dev.api.llamandoaldoctor.com",
    AUTH_0_DOMAIN:"lad-dev.auth0.com",
    AUTH_0_CLIENT_ID:"q6egfbYcBYXvdNqqdgPZPPCWo9ImHRom",
    callbackAuth: window.location.origin + '/dashboard',
    AMPLITUDE_PROJECT_ID: '172348',
    TOKBOX_URL_BASE: "https://tokbox.com/developer/tools/inspector/account/3117812/project/",
    TOKBOX_PROJECT_KEY: "45772292",
    TOKBOX_PROJECT_KEY_H264: "46203002",
    ENABLED_TO_SEND_LAD_REPORTS: "auth0|5b0459ba42f10e18ba750361,auth0|5f0f0aded44ed800195b4665"  // DefaultAdmin
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts